import React from 'react';
import { LuCircleAlert, LuRefreshCw } from 'react-icons/lu';
import Button from './Button';

/**
 * Shows a failed load: what went wrong, the error code when there is one, and a "Try again" button.
 */
const ErrorWidget = ({
  error,
  title = 'Something went wrong',
  onRetry = null,
  className = ''
}) => {
  if (!error) return null;

  const errorMessage = error?.message || error?.toString() || 'An unexpected error occurred';
  const errorCode = error?.code;

  return (
    <div
      role="alert"
      className={`mx-auto flex max-w-lg flex-col items-center rounded-xl border border-ui-line bg-ui-card px-6 py-8 text-center shadow-card ${className}`}
    >
      <div className="mb-3 flex size-11 items-center justify-center rounded-full bg-red-50 text-red-600 dark:bg-red-500/10 dark:text-red-300">
        <LuCircleAlert aria-hidden className="size-5" />
      </div>
      <h3 className="text-[15px] font-semibold text-ui-ink">{title}</h3>
      <p className="mt-1 text-sm whitespace-pre-line text-ui-ink-2">{errorMessage}</p>
      {errorCode && (
        <p className="mt-2 rounded bg-ui-muted px-2 py-0.5 font-mono text-xs text-ui-ink-3">
          Error code: {errorCode}
        </p>
      )}
      {onRetry && (
        <Button
          variant="secondary"
          className="mt-4"
          onClick={onRetry}
          leftIcon={<LuRefreshCw className="size-4" />}
        >
          Try again
        </Button>
      )}
    </div>
  );
};

export default ErrorWidget;
